const $ = window.$;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape

import Tagify from '@yaireo/tagify';
import {
  set_required_fields,
  create_searchable_dropdowns,
  toast_errors,
} from '_form_helpers';

"use strict";

var AdminVouchersEdit = {
  init: function() {

    create_searchable_dropdowns(
      [
        '#voucher_owner_id',
      ].join( ',' )
    );

    set_required_fields(
      [
        '.new_voucher',
        '.edit_voucher',
      ].join( ',' ),
      [
        { id: '#voucher_name', display: 'Name' },
        { id: '#voucher_usage_limit', display: 'Usage limit' },
        { id: '#voucher_per_user_limit', display: 'Per user limit' },
        { id: '#voucher_valid_from', display: 'Valid from' },
        { id: '#voucher_valid_to', display: 'Valid to', func: valid_to_check },
        { id: '#voucher_url', display: 'URL' },
      ]
    );

    function valid_to_check(){
      let $valid_to = $( '#voucher_valid_to' ),
          $valid_from = $( '#voucher_valid_from' );

      if ( $valid_to.length ) {
        if ( typeof $valid_to.val() === 'undefined' || $valid_to.val().trim() == '' ) {
          return true;
        } else {
          if ( ( Date.parse( $valid_from.val() ) >= Date.parse( $valid_to.val() ) ) ) {
            return [ true, 'Valid to date must be after the Valid from date' ];
          }
        }
      } else {
        return false;
      }
    }

    var inputElm = $( '.custom-input-tagify' ),
        current_target;

    window.tagify = [];

    inputElm.each( function(){
      var $this = $( this ),
          tag;
      tag = new Tagify( $this[ 0 ], {
            whitelist: [],
            enforceWhitelist: false,
            editTags: false,
            dropdown: {
              enabled: 1,
            },
            autoComplete: {
              enabled: false,
            },
            templates: {
              tag: function( tagData ) {
                return `<tag title='${ ( tagData.title || tagData.value ) }'
                                  contenteditable='false'
                                  spellcheck='false'
                                  tabIndex=' {this.settings.a11y.focusableTags ? 0 : -1} '
                                  class='${ this.settings.classNames.tag } ${ tagData.class ? tagData.class : "" }'
                                  ${ this.getAttributes( tagData ) }>
                          <x title='' class='${ this.settings.classNames.tagX }' role='button' aria-label='remove tag'></x>
                          <div>
                              <span class='${ this.settings.classNames.tagText }'>${ tagData[ this.settings.tagTextProp ] || tagData.value }</span>
                          </div>
                        </tag>`;
              },
              dropdownItem: function( tagData ) {
                return `<div class='tagify__dropdown__item ${ tagData.class ? tagData.class : "" }' tagifySuggestionIdx="${ tagData.tagifySuggestionIdx }">
                          <div class="d-flex align-items-center">
                            <span class='tagify__tag-color' style='background-color: ${ tagData.color }'></span>
                            <span class="ms-2">${ tagData.value }</span>
                          </div>
                        </div>`;
              },
              dropdownItemNoMatch: function( tagData ) {
                return `<span class="tagify__no_suggestion">No suggestion found for: ${ tagData.value }</span>`;
              }
            },
          } );

      tag.on( 'add', e => onAddTag( e, tag, $this, $this.data( 'tag-for' ) ) );
      tag.on( 'remove', e => onRemoveTag( e, tag, $this, $this.data( 'tag-for' ) ) );
      tag.settings.enforceWhitelist = false;
      tag.settings.templates.dropdownItemNoMatch = null;
      tag.settings.pattern = EMAIL_REGEX;
      tag.settings.delimiters = /\n|\r|,| /g;
      tag.settings.transformTag = transformTag;

      window.tagify.push( tag );
    } );

    $( document )
      .on( 'click', '.btn-vouchr-actor-group', function(){ voucher_actor_search( 'Group', 'company group', this ); } )
      .on( 'click', '.btn-vouchr-actor-company', function(){ voucher_actor_search( 'Company', 'company', this ); } );

    $( '#voucher_actor_modal' )
      .on( 'show.bs.modal', function() {
        $( '.modal-voucher' ).addClass( 'nested_blur' );
        $( '#voucher_actor_search, #voucher_actor_search_id, #voucher_actor_search_name, #voucher_actor_search_type, #voucher_actor_search_path, #voucher_actor_search_domain' ).val( '' );
      } )
      .on( 'shown.bs.modal', function() {
        $( '#voucher_actor_search' ).trigger( 'focus' );
      } )
      .on( 'hide.bs.modal', function() {
        $( '#voucher_actor_search' ).removeClass( 'is-invalid' );
        $( '#voucher_error_text_search' ).text( '' );
      } )
      .on( 'hidden.bs.modal', function() {
        $( '.modal-voucher' ).removeClass( 'nested_blur' );
      } );

    function voucher_actor_search( type, title, btn ){
      var query_params;

      current_target = $( btn ).parents( '.voucher-intended-for-content' );

      if ( type == 'Group' ) {
        query_params = type.toLowerCase() + '=User' + '&type=Company';
      } else {
        query_params = type.toLowerCase() + '=User';
      }

      $( '#voucher_actor_modal .modal-title' ).text( 'Add ' + title );

      initAutocomplete( '#voucher_actor_search',{ // eslint-disable-line no-undef
        appendTo:    $( '#voucher_actor_search' ).parent(),
        currentType: type,
        serviceUrl:  '/lookup?' + query_params
      } );

      $( '#voucher_actor_modal' ).modal( 'show' );
    }

    $( document ).on( 'click', '#voucher_actor_btn_add', function() {
      var id = ( new Date() ).getTime(),
          row,
          regx,
          template,
          r_name = $( '#voucher_actor_search_name' ).val(),
          r_path = $( '#voucher_actor_search_path' ).val(),
          r_type = $( '#voucher_actor_search_type' ).val(),
          r_id = $( '#voucher_actor_search_id' ).val(),
          r_domain = $( '#voucher_actor_search_domain' ).val(),
          actors = current_target.find( '.voucher-intended-for-box' ).html().replace( /\((.*?)\)/g, '$1' ),
          search = r_name.replace( /[.*+?^${}()|[\]\\]/g, '\\$&' );

      if ( r_name == undefined || r_name == '' ) {
        $( '#voucher_actor_search' ).addClass( 'is-invalid' );
      } else {
        regx = new RegExp( search, 'g' );
        if ( ( actors != undefined ) && ( actors.match( regx ) != null ) ) {
          $( '#voucher_actor_search' ).addClass( 'is-invalid' );
          $( '#voucher_error_text_search' ).text( 'This ' + r_type.toLowerCase() + ' has already been added' );
        } else {
          $( '#voucher_actor_search' ).removeClass( 'is-invalid' );
          $( '#voucher_error_text_search' ).text( '' );
          template = current_target.find( '#voucher_intended_for_template' ).text();
          row = template.replace( /{{new_id}}/g, id )
                        .replace( /{{r_id}}/g, r_id )
                        .replace( /{{r_type}}/g, r_type );
          current_target.find( '.voucher-intended-for-wrapper' ).append( row );
          current_target.find( '.voucher-intended-for-box' ).append(
            "<div class='tags actor border rounded d-flex flex-column " + r_type + " new'>" +
              "<span class='d-flex justify-content-between mt-4'>" +
                "<span class='py-1 px-2 rounded-end who_type_ribbon'>" + r_type + "</span>" +
                "<span class='d-flex'>" +
                  "<span class='d-none ready-to-save svg-icon svg-icon-3 svg-icon-dark ms-2 opacity-50'>" +
                    "<svg class='icon-ready-to-save'><use xlink:href='#icon-ready-to-save'></use></svg>" +
                  "</span>" +
                  "<span class='voucher-actor-remove btn-close pe-pointer ms-2 me-4'></span>" +
                "</span>" +
              "</span>" +
              "<a data-target-domain='" + r_domain + "' data-target-type='" + r_type + "' data-target-id='" + r_id + "' class='btn btn-sm fw-normal btn-color-gray-800 btn-active-color-primary text-start' href='" + r_path + "'>" + r_name + "</a>" +
            "</div>"
          );
          $( '#voucher_actor_modal' ).modal( 'hide' );
          clear_href();
        }
      }
    } );

    function clear_href() {
      $( '.voucher-intended-for-box' ).find( 'a' ).each( function() {
        if ( $( this ).attr( 'href' ) == '' ) {
          $( this ).removeAttr( 'href' );
        }
      } );
    }
    clear_href();

    $( document ).on( 'click', '.voucher-intended-for-box .tags .voucher-actor-remove', function(){
      var wrapper = $( this ).parents( '.voucher-intended-for-content' ).find( '.voucher-intended-for-wrapper' ),
          target_value = $( this ).parents( '.tags' ),
          target = $( wrapper ).find( 'input[value="' + target_value.find( 'a' ).data( 'target-type' ) + '"]' ).parent();

      $( target ).find( 'input[value="' + target_value.find( 'a' ).data( 'target-id' ) + '"]' ).parent().remove();
      $( target_value ).remove();
    } );

    function onAddTag( e, tag, element, base ) {
      var wrapper = element.parent().parent().find( '.tagify-wrapper' ),
          email_list=[],
          emails,
          isValid = e.detail.data.__isValid;

      if( isValid && isValid === true ){
        if ( base == 'voucher_contacts' ) {
          if ( tag.value.length <= 1 ) {
            $( '<input>' ).attr( {
              type: 'hidden',
              name: 'emails'
            } ).appendTo( $( wrapper ) );
            email_list.push( e.detail.data.value );
            $( 'input[type=hidden][name="emails"]' ).val( email_list.join( ',' ) );
          } else {
            emails = $( 'input[type=hidden][name="emails"]' );
            email_list = emails.val() ? emails.val().split( ',' ) : [];
            email_list.push( e.detail.data.value );
            emails.val( email_list.join( ',' ) );
          }
        } else if ( base == 'notification_emails' ) {
          emails = $( 'input[type=hidden][name="voucher[notification_emails]"]' );
          email_list = emails.val() ? emails.val().split( ',' ) : [];
          email_list.push( e.detail.data.value );
          emails.val( email_list.join( ',' ) );
        }
      }
    }

    function onRemoveTag( e, tag, element, base ) {
      if( !e.detail || !e.detail.data || !e.detail.data.value ){
        return;
      }
      var wrapper = element.parent().parent().find( '.tagify-wrapper' ),
          email_list,
          emails;

      if ( base == 'voucher_contacts' ) {
        if ( tag.value.length <= 0 ) {
          $( wrapper ).empty();
        } else {
          emails = $( 'input[type=hidden][name="emails"]' );
          email_list = emails.val() ? emails.val().split( ',' ) : [];
          email_list.splice( email_list.indexOf( e.detail.data.value ), 1 );
          emails.val( email_list.join( ',' ) );
        }
      } else if ( base == 'notification_emails' ) {
        emails = $( 'input[type=hidden][name="voucher[notification_emails]"]' );
        email_list = emails.val() ? emails.val().split( ',' ) : [];
        email_list.splice( email_list.indexOf( e.detail.data.value ), 1 );
        emails.val( email_list.join( ',' ) );
      }
    }

    function transformTag( tag ) {
      var err_msg;
      if ( EMAIL_REGEX.test( tag.value ) ) {
        tag.style = "--tag-bg: var(--bs-success)";
      }else{
        err_msg = `${tag.value} is invalid!`;
        if ( tag.value.toLowerCase().includes( 'mailto:' ) ){
          err_msg += '<br> It must not contain "mailto:" identifier';
        }
        toast_errors( err_msg );
      }
    }
  }
};

$( function(){
  AdminVouchersEdit.init();
} );
